
/**
 * 강의 콘텐츠 유형
 */
export type CourseDetailLocalizedSectionsItemSectionsItemLecturesItemContentType = typeof CourseDetailLocalizedSectionsItemSectionsItemLecturesItemContentType[keyof typeof CourseDetailLocalizedSectionsItemSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDetailLocalizedSectionsItemSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  ASSIGNMENT: 'ASSIGNMENT',
  LIVE: 'LIVE',
  DISCUSSION: 'DISCUSSION',
  ARTICLE: 'ARTICLE',
  UNKNOWN: 'UNKNOWN',
} as const;
